/**
  * loadState
  * @desc if localstorage exists, return the stored state
  * @return {Object} state processed state
*/
export const loadState = () => {
  try {
    const serialState = localStorage.getItem('state')
    if (serialState === null) {
      return undefined
    }
    return JSON.parse(serialState)
  } catch (err) {
    return undefined
  }
}
/**
  * saveState
  * @desc save the redux state to local Storage
  * @param {Object} state current redux state
*/
export const saveState = (state) => {
  try {
    const serialState = JSON.stringify(state)
    localStorage.setItem('state', serialState)
  } catch (err) {
    // do nothing on write error
  }
}
